module.exports = __webpack_public_path__ + "static/key-triofmadness-868b353bb42d3915500ce8b09a152c0a.webp";